import { IMediaModel } from "@nf/common";
import dynamic from "next/dynamic";

import MediaActionButtons from "components/Media/MediaActionButtons";
import MediaCategories from "components/Media/MediaCategories";
import MediaCoverImage from "components/Media/MediaCoverImage";
import MediaDescription from "components/Media/MediaDescription";
import MediaDetailsAdditionalInfo from "components/Media/MediaDetailsAdditionalInfo";
import MediaDetailsDescriptionList from "components/Media/MediaDetailsDescriptionList";
import MediaExtraMaterials from "components/Media/MediaExtraMaterials";
import MediaDetailsScreen from "screens/MediaDetailsScreen";
import { useMediaParentalRatingGuard } from "../../hooks";

const MediaArticleField = dynamic(
  () => import("components/Media/MediaArticleField")
);

import styles from "./MovieDetailsScreen.module.scss";

export type MediaDetailsScreenProps = {
  media?: IMediaModel;
  extraMaterials?: IMediaModel[];
  relatedMaterials?: IMediaModel[];
};

export const MovieDetailsScreen = ({
  media,
  extraMaterials,
  relatedMaterials,
}: MediaDetailsScreenProps) => {
  useMediaParentalRatingGuard(media);

  if (!media) {
    return null;
  }

  return (
    <MediaDetailsScreen media={media}>
      <div className={styles.container}>
        <div className={styles.content}>
          <MediaDetailsAdditionalInfo media={media} />

          <MediaActionButtons media={media} showTrailer={media.IsPlayable} />

          <MediaCategories media={media} />

          <MediaDescription media={media} />

          <MediaDetailsDescriptionList media={media} />
        </div>

        <div className={styles.cover}>
          <MediaCoverImage media={media} />
        </div>

        {!!extraMaterials?.length && (
          <MediaExtraMaterials
            title="web_extramaterial"
            mediaList={extraMaterials}
          />
        )}

        {!!relatedMaterials?.length && (
          <MediaExtraMaterials
            title="web_asset_page_related_movies"
            mediaList={relatedMaterials}
          />
        )}

        {media?.Article && <MediaArticleField article={media.Article} />}
      </div>
    </MediaDetailsScreen>
  );
};

export default MovieDetailsScreen;
